module.exports = __webpack_public_path__ + "img/newzealand.3c3669fc.png";